import { ContentContainer } from "Admin/Components";
import { getUnitSummary } from "Admin/Service/Unit";
import { addItem } from "Redux/Slices/BreadCrumb";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { contentList } from "./Components/contentList";
import styles from "./UnitDetail.module.scss";
const RoleDetail = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const entity_credential = useLocation().pathname.split("/")[3];
  const entity_id = useLocation().pathname.split("/")[3].split("-")[0];
  const entity_type = useLocation().pathname.split("/")[3].split("-")[1];
  const [selectedTag, setSelectedTag] = useState(null);
  const contentRoleList = contentList(entity_credential);
  const pathname = useLocation().pathname;
  const [summary, setSummary] = useState({});
  useEffect(() => {
    if (user) {
      contentRoleList.map((item, index) => {
        if (item.path == pathname) {
          setSelectedTag(contentRoleList[index]);
        }
      });
    }
    getUnitSummary(entity_id, entity_type, (res) => {
      dispatch(
        addItem({
          key: res.name,
          label: res.name,
          to: `/units/${entity_id}-${entity_type}/summary`,
          name: res.name,
          level: 2,
        })
      );
      setSummary(res);
    });
  }, [user, entity_credential]);
  return (
    <div className={styles["role-detail"]}>
      <ContentContainer
        items={contentRoleList}
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        summary={summary}
      />
    </div>
  );
};

export default RoleDetail;
